import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { IField } from '@shared/model/basic-data';

@Injectable({
  providedIn: 'root',
})
export class AdditionalSettingsService {
  private _baseUrl: string = `${environment.apiUrl}/projects/copied_project`;

  constructor(private _http: HttpClient) {}

  getAdditionalSettings(id: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/${id}/`);
  }

  updateAdditionalSettings(id: number, data: IField): Observable<any> {
    return this._http.patch(`${this._baseUrl}/${id}/`, {
      [data.name]: data.value,
    });
  }
}
